var UvsityCommonModule = /** @class */ (function () {
    function UvsityCommonModule() {
    }
    return UvsityCommonModule;
}());
export { UvsityCommonModule };
//# sourceMappingURL=uvsity.common.module.js.map